import { connect } from 'react-redux';

import { IState } from '../../store';
import { SimilarOffersGroupsComponent } from './groups_component';
import { ISimilarState } from '../../store/similar';

export interface ISimilarOffersGroupsProps {
  withoutCompetitors: boolean;
}

export function hasWithoutCompetitors(similarOffers: ISimilarState): boolean {
  return Object.keys(similarOffers).some((modelType: 'userBased' | 'itemBased') =>
    Boolean(similarOffers[modelType].withoutCompetitors));
}

export function mapStateToProps(state: IState): ISimilarOffersGroupsProps {
  const { similarOffers } = state;
  const withoutCompetitors = hasWithoutCompetitors(similarOffers);

  return { withoutCompetitors };
}

export const SimilarOffersGroupsContainer = connect<ISimilarOffersGroupsProps>(
  mapStateToProps,
)(SimilarOffersGroupsComponent);
